import axios from "axios";
import qs from "qs";
import appHelper from "./app_helper";
//import dialogHelper from "./dialog_helper";
import notifyHelper from "./notify_helper";
import objectHelper from "./object_helper";
import app from "../main";
import md5 from "md5";

const httpHelper = {
    get: async function (url, data = {}, options) {
        return await this.sendRequest(url, data, 'get', options);
    },
    delete: async function (url, data = {}, options) {
        return await this.sendRequest(url, data, 'delete', options);
    },
    post: async function (url, data = {}, options = {type: "formData"}) {
        return await this.sendRequest(url, data, 'post', options);
    },
    put: async function (url, data = {}, options) {
        return await this.sendRequest(url, data, 'put', options);
    },
    patch: async function (url, data = {}, options) {
        return await this.sendRequest(url, data, 'patch', options);
    },
    sendRequest: async function (url, data = {}, method = 'get', options = {}) {

        // Process options
        options = objectHelper.mergeTo(options, {
            contentType: 'application/json',
            showAlert: true,
            fail: null,
        })

        let lowerUrl = url.toLowerCase();
        if (!lowerUrl.startsWith('http://') && !lowerUrl.startsWith('https://'))
            url = appHelper.settings.apiURL + url;

        if (options.type === 'formData') {
            options.contentType = 'multipart/form-data';
        }

        // Process data
        if (!data)
            data = {};

        data.languageCode = appHelper.settings.languageCode;
        let userInfo = app.$store.getters.userInfo;
        if (userInfo) {
            data.username = userInfo.username;
            data.deviceId = userInfo.deviceId;
            data.timestamp = parseInt((new Date()).getTime()/1000);
            let signature = `username=${data.username}&password=${data.password}&deviceId=${data.deviceId}&timestamp=${data.timestamp}`;
            data.signature = md5(signature);
        }

        let params = null;
        if (['post'].includes(method)) {
            params = {...data};
            data = null;
        }

        // Process axios options
        let axiosOptions = {
            method: method,
            url: url,
            data: data,
            headers: {
                'Content-Type': options.contentType
            },
            //responseType: 'json',
            params: params,
            paramsSerializer: params => {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            },
            onUploadProgress: () => {

            },
            onDownloadProgress: async () => {

            }
        };

        let proxySettings = await appHelper.getSetting("proxySettings");
        if (proxySettings && proxySettings.on) {
            let proxy = {
                protocol: proxySettings.protocol,
                host: proxySettings.host,
                port: proxySettings.port,
            };

            if (typeof proxySettings.username === "string" && proxySettings.username.length > 0)
                proxy.auth = {
                    username: proxySettings.username,
                    password: proxySettings.password
                }

            axiosOptions.proxy = proxy;
        }

        let response = await axios(axiosOptions).catch(err => {

        });

        if (!response) {
            if (options.showAlert)
                //await dialogHelper.alert('Failed to connect to server. Please check your internet connection.', "error");
                notifyHelper.error('Failed to connect to server. Please check your internet connection.');

            if (options.fail != null)
                options.fail();
        }

        return response ? response.data : null;
    }
}

export default httpHelper;